import { Action } from '@ngrx/store';


export enum AdmGrpCartoActionTypes {
  GET_ADM_GCARTO = '[ADM_CARTO] GetGrpCarto',
  SET_ADM_GCARTO = '[ADM_CARTO] SetGrpCarto',
  EDIT_ADM_GCARTO = '[ADM_CARTO] EditGrpCarto',
  DELETE_ADM_GCARTO = '[ADM_CARTO] DeleteGrpCarto',
  SUCESS_GCARTO = '[ADM_CARTO] SuccessGrpCarto',
  FAIL_GCARTO = '[ADM_CARTO] FailGrpCarto',
}

export class AdmGetGrpCarto implements Action {
  readonly type = AdmGrpCartoActionTypes.GET_ADM_GCARTO;
  constructor() { }
}

export class AdmSetGrpCarto implements Action {
  readonly type = AdmGrpCartoActionTypes.SET_ADM_GCARTO;
  constructor(public DatosGrpCarto: any) { }
}
export class AdmEditGrpCarto implements Action {
  readonly type = AdmGrpCartoActionTypes.EDIT_ADM_GCARTO;
  constructor(public DatosGrpCarto: any) { }
}

export class AdmDeleteGrpCarto implements Action {
  readonly type = AdmGrpCartoActionTypes.DELETE_ADM_GCARTO;
  constructor(public ObjDel: any) { }
}

export class AdmSuscessGrpCarto implements Action {
  readonly type = AdmGrpCartoActionTypes.SUCESS_GCARTO;
  constructor(public Respuesta: any, public TipoR: string) { }
}

export class AdmFailGrpCarto implements Action {
  readonly type = AdmGrpCartoActionTypes.FAIL_GCARTO;
  constructor(public Respuesta: any) { }
}


export type AdmGrpCartoAcciones =
  | AdmGetGrpCarto
  | AdmSetGrpCarto
  | AdmEditGrpCarto
  | AdmDeleteGrpCarto
  | AdmSuscessGrpCarto
  | AdmFailGrpCarto;
